export default (props) => (
  /**
   * Ícone escala da cores degradê azul.
   * Utilizada no dropdown "Escala de cores"
   * na edição de simbologia.
   */
  <svg
    width="176"
    height="22"
    viewBox="0 0 176 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.447266 3.59375C0.447266 1.9369 1.79041 0.59375 3.44727 0.59375H17.9643V22.0053H3.44727C1.79041 22.0053 0.447266 20.6621 0.447266 19.0053V3.59375Z"
      fill="#0245A5"
    />
    <path
      d="M175.618 19.0078C175.618 20.6647 174.275 22.0078 172.618 22.0078L158.101 22.0078L158.101 0.596299L172.618 0.5963C174.275 0.5963 175.618 1.93945 175.618 3.5963L175.618 19.0078Z"
      fill="#DFF3FE"
    />
    <path
      d="M17.9648 0.59375H35.4819V22.0053H17.9648V0.59375Z"
      fill="#0363C4"
    />
    <path
      d="M35.4814 0.59375H52.9985V22.0053H35.4814V0.59375Z"
      fill="#0076D3"
    />
    <path
      d="M52.9985 0.59375H70.5156V22.0053H52.9985V0.59375Z"
      fill="#0087EA"
    />
    <path
      d="M70.5151 0.59375H88.0322V22.0053H70.5151V0.59375Z"
      fill="#0096F4"
    />
    <path 
      d="M88.0327 0.59375H105.55V22.0053H88.0327V0.59375Z" 
      fill="#01A8F8" 
    />
    <path 
      d="M105.55 0.59375H123.067V22.0053H105.55V0.59375Z" 
      fill="#00B8FB" 
    />
    <path
      d="M123.066 0.59375H140.583V22.0053H123.066V0.59375Z"
      fill="#73C8FC"
    />
    <path
      d="M140.584 0.59375H158.101V22.0053H140.584V0.59375Z"
      fill="#ACDFFE"
    />
  </svg>
);
